import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { Dialog, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import React from 'react';
import AddAccountForm from './AddAccountForm';

interface Props {
  classes: any;
  open: boolean;
  onClose: () => void;
}

const styles = (theme: JupiterTheme) => ({
  groupPanelSubheaderText: {
    color: theme.palette.primary.main,
  },
  modalBody: {
    padding: theme.spacing(3),
    minWidth: '450px',
  },
});

const AddAccountModal = ({ classes, onClose, open }: Props) => (
  <Dialog onClose={onClose} open={open}>
    <div className={classes.modalBody}>
      <Typography variant="h5" className={classes.groupPanelSubheaderText}>
        Create an Account
      </Typography>
      <AddAccountForm onSubmit={onClose} />
    </div>
  </Dialog>
);

export default withStyles(styles)(AddAccountModal);
export { AddAccountModal as AddAccountModalUnwrapped };
